(ns frontend.ux-overhaul.listing.screening.sub
  (:require
   [frontend.ux-overhaul.listing.screening.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::bulk-edit-open?
 :<-
 [::state]
 (fn [state _]
   (boolean (get state model/bulk-edit-open?-key))))
